export default {
  AVAILABLE_FOR_OVER_AMOUNT: 'Eligible for orders over ¥{AMOUNT}',
  AVAILABLE_FOR_OVER_QUANTITY: 'Available for {QUANTITY} Items',
  FOREACH_QUANTITY_GET_QUANTITY_FREE:
    'Available for Every {QUANTITY} Items Purchased',
  DISCOUNT_CHEAPEST_NOF_M: 'Enjoy the Lowest Single Price for {QUANTITY} Items',
  ZERO_THRESHOLD_IS_AVAILABLE: 'No Threshold Available',
  FREE_SHIPPING_FOR_X_PIECES: 'Free Shipping for {QUANTITY} Items',
  ALL_CATEGORY_BENEFITS_FOR_FULL_SELECTION: 'Full site products',
  TAKE_IT_NOW: 'Claim',
  TO_USE: 'Use',
  REDEEMED: 'Available',
  USED: 'Used',
  EXPIRED: 'Expired',
  ALREADY_SOLD_OUT: 'Sold Out',
  NOT_STARTED: 'Not Started',
  SEE_MORE: 'Click to View More',
  CLAIMED_SUCCESSFULLY: 'Successfully Claimed',
  CLAIMED_FAILED: 'Failed to Claim',
  NO_COUPON: 'No coupon available',
  UNAVAILABLE: 'Not Available',
  AVAILABLE_GOODS: 'Available Products'
};
